"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var horizontalReportCard_1 = require("../horizontal-report-card/horizontalReportCard");
var activeCalls_icon_1 = require("../../../svg/activeCalls.icon");
var agentsLoggedIn_icon_1 = require("../../../svg/agentsLoggedIn.icon");
var callsInQueue_icon_1 = require("../../../svg/callsInQueue.icon");
var agentsWithCustomers_icon_1 = require("../../../svg/agentsWithCustomers.icon");
var reportCardContainer_styles_1 = require("./reportCardContainer.styles");
var core_components_1 = require("@securityproducts/core-components");
var reportCardContainer_i18n_1 = require("./reportCardContainer.i18n");
function ReportCardContainer(props) {
    var strings = core_components_1.useLocalisation(reportCardContainer_i18n_1.reportsCardContainerTranslations, props.language);
    return (React.createElement(core_components_1.ErrorBoundary, null,
        React.createElement("div", { id: "reports-card-container", className: reportCardContainer_styles_1.container },
            React.createElement("div", { className: reportCardContainer_styles_1.row },
                React.createElement(horizontalReportCard_1.HorizontalReportCard, { id: "total-active-calls", label: strings.totalActiveCalls, value: props.totalActiveCalls },
                    React.createElement(activeCalls_icon_1.ActiveCallsIcon, null)),
                React.createElement(horizontalReportCard_1.HorizontalReportCard, { id: "agents-logged-in", label: strings.agentsLoggedIn, value: props.agentsLoggedIn },
                    React.createElement(agentsLoggedIn_icon_1.AgentsLoggedInIcon, null)),
                React.createElement(horizontalReportCard_1.HorizontalReportCard, { id: "calls-in-queue", label: strings.callsInQueue, value: props.callsInQueue },
                    React.createElement(callsInQueue_icon_1.CallsInQueueIcon, null)),
                React.createElement(horizontalReportCard_1.HorizontalReportCard, { id: "agents-with-customer", label: strings.agentsWithCustomers, value: props.agentsWithCustomers },
                    React.createElement(agentsWithCustomers_icon_1.AgentsWithCustomersIcon, null))))));
}
exports.ReportCardContainer = ReportCardContainer;
